export function slugify (str) {
  str = str.replace(/^\s+|\s+$/g, '') // trim leading/trailing white space
  str = str.toLowerCase() // convert string to lowercase
  str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-') // remove consecutive hyphens
  return str
}

function ctaOnClick (e, cta, target) {
  e.preventDefault()
  if (cta.url.startsWith('https://') || cta.url.startsWith('http://')) {
    window.open(cta.url, target)
  } else if (cta.url.startsWith('mailto')) {
    window.open(cta.url, target)
  } else {
    window.open(`https://${cta.url}`, target)
  }
}

export default function hideOrShowCTA (params) {
  const { currentTime, callToActions, settings } = params
  if (callToActions) {
    window.ctaOnClick = ctaOnClick
    let i = 0
    for (const cta of callToActions) {
      const existingCTA = document.getElementById(`cta_${i}`)
      if (
        Math.floor(currentTime) >= Math.floor(cta.startTime) &&
                Math.floor(currentTime) <= Math.floor(cta.endTime) &&
                !existingCTA
      ) {
        const flex = document.createElement('div')
        flex.className = 'absolute'
        flex.id = `cta_${i}`

        const spanElement = document.createElement('span')
        spanElement.className = 'cta_button'
        // let timeToSpend = 700
        const target = cta && Object.hasOwn(cta, 'htmlTarget') ? cta.htmlTarget : '_blank' || '_blank'
        let ctaEventId
        if (window.gumletInsights) {
          ctaEventId = `${slugify(cta.text)}_${cta.startTime}_${cta.endTime}`
        }
        // if (target === '_blank') { timeToSpend = 0 }
        spanElement.addEventListener('click', (e) => {
          if (window.gumletInsights) {
            window.gumletInsights.customEventHandlerAsync('custom_cta_click_embed', { id: ctaEventId }).then(res => {
              window.ctaOnClick(e, cta, target)
            }).catch(() => {
              window.ctaOnClick(e, cta, target)
            })
          } else {
            window.ctaOnClick(e, cta, target)
          }

          if (settings.webhookUrl) {
            const payload = {
              cta,
              index: i,
              currentTime
            }
            fetch(settings.webhookUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-gumlet-agent': 'gumlet-embed'
              },
              body: JSON.stringify({
                event: 'event.embed.cta_clicked',
                payload,
                assetId: settings.videoId
              })
            }).catch(error => {
              console.error('Error:', error)
            })
          }
        })

        if (cta.positionFromTop) { flex.style.top = cta.positionFromTop + '%' }
        if (cta.positionFromRight) { flex.style.right = cta.positionFromRight + '%' }

        if (cta.position && cta.position === 'top-left') {
          flex.style.top = '10px'
          flex.style.left = '10px'
        }
        if (cta.position && cta.position === 'top-right') {
          flex.style.top = '10px'
          flex.style.right = '10px'
        }
        if (cta.position && cta.position === 'bottom-left') {
          flex.style.bottom = '65px'
          flex.style.left = '10px'
        }
        if (cta.position && cta.position === 'bottom-right') {
          flex.style.bottom = '65px'
          flex.style.right = '10px'
        }
        if (cta.position && cta.position === 'center') {
          flex.style.top = '50%'
          flex.style.left = '50%'
          flex.style.transform = 'translate(-50%, -50%)'
        }

        // add z-index to the cta
        flex.style.zIndex = 1000

        // transform the position to the bottom right // tempo condition to solve center position
        if (cta?.positionFromTop === 50 && cta?.positionFromRight === 50) {
          flex.style.transform = 'translate(50%, -50%)'
        }

        if (cta.fontColor) { spanElement.style.color = cta.fontColor }
        if (cta.backgroundColor) { spanElement.style['background-color'] = cta.backgroundColor }

        spanElement.textContent = cta.text
        spanElement.style.zIndex = 999
        cta.running = true
        cta.id = `cta_${i}`

        document.getElementsByClassName('player-wrapper')[0].appendChild(flex)
        document.getElementById(flex.id).appendChild(spanElement)
        if (window.gumletInsights) {
          window.gumletInsights.customEventHandler('custom_cta_impression_embed', { id: ctaEventId })
        }
      } else if (
        (
          Math.floor(currentTime) > Math.floor(cta.endTime) ||
                    Math.floor(currentTime) < Math.floor(cta.startTime)
        ) &&
                existingCTA
      ) {
        cta.running = false
        document.getElementsByClassName('player-wrapper')[0].removeChild(document.getElementById(`cta_${i}`))
      }
      i += 1
    }
  }
}
